import React from 'react'

import Context from './Context'

const Provider = props => (
  <Context.Provider value={props.viewportElement}>
    {props.children}
  </Context.Provider>
)

export default Provider
